module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp13_0.5844ba41.png";